/* eslint-disable */

import { createStore } from "vuex";
const req = require.context(".", true, /\.js$/);

const modules = {};

req.keys().forEach((fileName) => {
  if (fileName === "./index.js") return;
  let moduleName = fileName.replace(/(\.\/|\.js)/g, "");
  let fileItems = req(fileName);

  if (moduleName.includes("/index")) moduleName = moduleName.replace("/index", "");

  modules[moduleName] = { state: {}, mutations: {}, actions: {}, getters: {}, ...fileItems, namespaced: true };
});

export default createStore({
  namespaced: true,
  modules
});
